import { validations, sleep } from '@/plugins/xtpgui';

export default {
    namespaced: true,

    state: {
        schema: {},
        info: {},
        user: {},
        

        messenger: {
            window: 0,
            sequence: 3,
            // user: { id: 'df09ed38-0170-46f6-b4eb-62737a9415c9' },
            fields: {
                valid: false,
                text: {
                    value: null,
                    rules: [
                        validations.required,
                    ]
                }
            },
            users: [
                {
                    id: '662388e6-bdd8-4694-b6a6-f378a83d2b3e',
                    name: 'JOÃO BATISTA',
                    alias: 'JOÃO',
                    profile: 'ADMIN',
                    avatar: '/avatars/1.jpg',
                    status: 'on',
                    messages: []
                },
                {
                    id: 'df09ed38-0170-46f6-b4eb-62737a9415c9',
                    name: 'LETÍCIA SILVA',
                    alias: 'LETÍCIA',
                    profile: 'ADMIN',
                    avatar: '/avatars/3.jpg',
                    status: 'on',
                    messages: []
                },
                {
                    id: '3d6d909c-8b25-428d-a5f3-4466acd1820f',
                    name: 'MASTER ADMINISTRADOR',
                    alias: 'MASTER',
                    profile: 'ADMIN',
                    avatar: '/avatars/2.jpg',
                    status: 'on',
                    messages: [
                        {
                            id: 1,
                            sendDate: '2022-01-01 15:00:00',
                            text: 'Oi Cássia, como vai?',
                            right: true,
                            from : {
                                id: '3d6d909c-8b25-428d-a5f3-4466acd1820f',
                                name: 'MASTER ADMINISTRADOR',
                                alias: 'MASTER',
                                profile: 'ADMIN'
                            },
                            to: {
                                id: '6c98dae0-6533-4415-b7c5-e14af646a753',
                                name: 'CÁSSIA GOMES',
                                alias: 'CÁSSIA',
                                profile: 'ADMIN'
                            }
                        },
                        {
                            id: 2,
                            sendDate: '2022-01-01 15:00:00',
                            text: 'Tudo bem Mariana e vc?',
                            right: false,
                            from: {
                                id: '6c98dae0-6533-4415-b7c5-e14af646a753',
                                name: 'CÁSSIA GOMES',
                                alias: 'CÁSSIA',
                                profile: 'ADMIN'
                            },
                            to : {
                                id: '3d6d909c-8b25-428d-a5f3-4466acd1820f',
                                name: 'MASTER ADMINISTRADOR',
                                alias: 'MASTER',
                                profile: 'ADMIN'
                            }
                        },
                        {
                            id: 3,
                            sendDate: '2022-01-01 15:00:00',
                            text: 'Tudo ótimo, vc conseguiu fazer o relatório do cliente XPTO?',
                            right: true,
                            from : {
                                id: '3d6d909c-8b25-428d-a5f3-4466acd1820f',
                                name: 'MASTER ADMINISTRADOR',
                                alias: 'MASTER',
                                profile: 'ADMIN'
                            },
                            to: {
                                id: '6c98dae0-6533-4415-b7c5-e14af646a753',
                                name: 'CÁSSIA GOMES',
                                alias: 'CÁSSIA',
                                profile: 'ADMIN'
                            }
                        },
                    ]
                },
                {
                    id: 'c3c359c0-cad0-44dd-8eae-10779409dd81',
                    name: 'MADALENA BONA FONTE',
                    alias: 'MADALENA',
                    profile: 'ADMIN',
                    avatar: '/avatars/4.jpg',
                    status: 'busy',
                    messages: []
                },
                {
                    id: '6c98dae0-6533-4415-b7c5-e14af646a753',
                    name: 'CÁSSIA GOMES',
                    alias: 'CÁSSIA',
                    profile: 'ADMIN',
                    avatar: '/avatars/5.jpg',
                    status: 'on',
                    messages: []
                },
            ],
        },
    },

    mutations: {
        SET_SCHEMA(state, schema) {
            state.schema = schema;
        },

        SET_INFO(state, info) {
            state.info = info;
        },

        SET_USER(state, user) {
            state.user = user;
        },

        SET_CHAT_WINDOW(state, window) {
            state.messenger.window.current = window;
        },

        SET_CHAT_USER(state, user) {
            state.chat.user = user;
        },

        SEND_MESSAGE(state, msg) {
            state.messenger.sequence = state.messenger.sequence + 1;
            msg.id = state.messenger.sequence;
            msg.sendDate = window.moment();
            msg.right = true;
            msg.from = {
                id: state.user.id,
                name: state.user.name,
                alias: state.user.name.split(' ')[0],
                profile: state.user.profile
            };
            msg.to = {
                id: state.messenger.user.id,
                name: state.messenger.user.name,
                alias: state.messenger.user.alias,
                profile: state.messenger.user.profile
            };
            state.messenger.user.messages.push(msg);

            setTimeout(() => {
                state.messenger.sequence = state.messenger.sequence + 1;
                const _msg = JSON.parse(JSON.stringify(msg));

                state.messenger.user.messages.push({
                    id: state.messenger.sequence,
                    sendDate: window.moment(),
                    text: `Olá ${_msg.from.alias}, recebi sua mensagem e logo estarei retomando esse assunto.`,
                    right: false,
                    from: _msg.to,
                    to: _msg.from
                });
            }, 1300);
        },
    },

    actions: {

    },
}
